import React, { InputHTMLAttributes } from 'react'
import {
  FieldValues,
  UseFormRegister,
  Path,
  RegisterOptions,
  GlobalError,
  FieldErrorsImpl,
} from 'react-hook-form'
import { NAMESPACE } from '../utils'

interface FieldErrors<U extends FieldValues> {
  root?: Record<string, GlobalError> & GlobalError
  [key: string]: FieldErrorsImpl<U> | GlobalError | undefined
}

interface CheckboxProps<T extends FieldValues>
  extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  name: Path<T>
  register?: UseFormRegister<T>
  errors?: FieldErrors<T>
  validation?: RegisterOptions<T, Path<T>>
  disabled?: boolean
  widthClass?: string
  labelClassName?: string
  dataQaId?: string
  customStyles?: object
}

const Checkbox = <T extends FieldValues>({
  label,
  name,
  register,
  errors,
  validation,
  disabled,
  widthClass,
  labelClassName = '',
  dataQaId = '',
  customStyles = {},
  ...rest
}: CheckboxProps<T>) => {
  return (
    <div className="flex items-center gap-2 font-primary font-light text-xs">
      <label
        htmlFor={name}
        className={`flex items-center gap-2 ${labelClassName}`}
        style={{ ...customStyles }}
      >
        <input
          data-qa-id={dataQaId || ''}
          type="checkbox"
          id={name}
          disabled={disabled}
          {...(register ? register(name, { ...validation }) : { name })}
          {...rest}
          style={{ ...customStyles }}
          className={`flex-shrink-0 accent-secondary-500 ${
            widthClass ?? 'h-[1.125rem] w-[1.125rem]'
          } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        />
        {label !== '' ? (
          <span
            className={`label-text cursor-pointer  ${
              disabled ? 'text-accent-400' : 'text-accent-900'
            }`}
            style={{ ...customStyles }}
          >
            {label}{' '}
            {(validation?.required || rest?.required) && (
              <span
                className="ml-1 text-xs leading-1  text-error-500 font-extraLight "
                style={{ ...customStyles }}
              >
                *
              </span>
            )}
          </span>
        ) : null}
      </label>
      <div>
        {errors &&
          name &&
          errors?.[name] &&
          errors?.[name]?.['type'] === 'required' && (
            <span
              className="text-error-500 text-xxs font-primary font-extraLight"
              style={{ ...customStyles }}
            >
              {NAMESPACE?.REQUIRED_FIELD}
            </span>
          )}
      </div>
    </div>
  )
}

export default Checkbox
